import { CategoricalThresholdBar } from './CategoricalThresholdBar.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { useCategoricalBarChartBaseConfig } from '../../hooks/useCategoricalBarChartBaseConfig.js';
import { AREAS } from '../../types/categorical-bar-area-rules.js';
import { isVertical } from '../../utils/layout.js';

export const CategoricalThresholdArea = () => {
  const { layout } = useCategoricalBarChartBaseConfig();

  return isVertical(layout) ? (
    <ChartGrid.GridArea gridArea={AREAS.leftThreshold}>
      {({ availableHeight }) => (
        <CategoricalThresholdBar length={availableHeight} />
      )}
    </ChartGrid.GridArea>
  ) : (
    <ChartGrid.GridArea gridArea={AREAS.bottomThreshold}>
      {({ availableWidth }) => (
        <CategoricalThresholdBar length={availableWidth} />
      )}
    </ChartGrid.GridArea>
  );
};

CategoricalThresholdArea['displayName'] = 'CategoricalThresholdAxis';
